/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DisplayRetailer = {
    id: number;
    name: string;
    status: DisplayRetailer.status;
};

export namespace DisplayRetailer {

    export enum status {
        ACTIVE = 'ACTIVE',
        DISABLED = 'DISABLED',
    }


}

